var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"Pesanan"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"card"},[[_c('PesananTable',{attrs:{"transactionRecap":_vm.transactionRecap}})]],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }